<script>
    import Project from '../js/project';
    import Skill from '../js/project';
    import Button from '../js/button';
    import ProjectDisplay from '../components/project_display.svelte';

    const projects = [
        new Project(
            "MusicFix",
            "Business Project",
            "I made this complete app from scratch. I did the development, the graphics design and the animated icons in the navigation bar. Customer was very happy with it, and it was done very efficiently in 2 months.",
            [
                new Skill("Flutter", 4),
                new Skill("Dart", 4),
                new Skill("TypeScript", 3),
                new Skill("Firebase", 4),
                new Skill("Google Admob", 3),
                new Skill("Rive", 3),
                new Skill("OpenAI", 2),
                new Skill("Trello", 2),
                new Skill("Git", 3),
                new Skill("Android Studio", 4),
            ],
            [
                new Button("AppStore", 'https://apps.apple.com/dk/app/musicfix/id6741480683'),
                new Button("PlayStore", 'https://play.google.com/store/apps/details?id=com.musicfix.musicfix.music_fix'),
            ],
            [
                "https://firebasestorage.googleapis.com/v0/b/portfolio-frederik.appspot.com/o/images%2Fmusicfix.png?alt=media&token=5093d5b8-3637-4f0f-835a-bee62407a8ca",
            ],
        ),
        new Project(
            "Wordoss",
            "Personal Business Project",
            "I started this project ahead of my education. It is a casual Language Learning App, where people can learn and practice a language through Language Exchange using AI for answering people’s messages. The app is on the AppStore and PlayStore, and has been downloaded in more than 150 countries.",
            [
                new Skill("Flutter", 4),
                new Skill("Dart", 4),
                new Skill("Firebase", 4),
                new Skill("Google Admob", 3),
                new Skill("Rive", 3),
                new Skill("OpenAI", 2),
                new Skill("Trello", 2),
                new Skill("Git", 3),
                new Skill("Android Studio", 4),
            ],
            [
            ],
            [
                "https://firebasestorage.googleapis.com/v0/b/portfolio-frederik.appspot.com/o/images%2Fw2-min.png?alt=media&token=58a4d7b0-9320-4716-a66d-83018063e3ad",
            ],
        ),
        new Project(
            "LanguageLift",
            "Personal Business Project",
            "I started this project to accompany the Wordoss app. I wanted to make a less complicated app, where I could really put my focus on the UI and the User Experience. It is a simple and casual Language Learning App, where people can learn different phrases in their target language each day.",
            [
                new Skill("Flutter", 4),
                new Skill("Dart", 4),
                new Skill("Firebase", 4),
                new Skill("Rive", 3),
                new Skill("Trello", 2),
                new Skill("Git", 2),
                new Skill("Android Studio", 4),
            ],
            [
            ],
            [
                "https://firebasestorage.googleapis.com/v0/b/portfolio-frederik.appspot.com/o/images%2Fll2-min.png?alt=media&token=7e368eda-bc67-459c-bfa8-0a05eb774204",
                "https://firebasestorage.googleapis.com/v0/b/portfolio-frederik.appspot.com/o/images%2Fll1-min.png?alt=media&token=7c29f69f-95dc-4a9b-901c-f1ce23dfc641",
            ],
        ),
       new Project(
            "LanguageLens",
            "Exam Project",
            "This project was for the exam in Mobile Development. It is an app, that can identify a language from text. Originally, I chose to use my model from the Machine Learning Exam Project, but Google had already made a better one, so I went with that.",
            [
                new Skill("React Native", 3),    
                new Skill("TypeScript", 3),
                new Skill("Firebase", 4),
                new Skill("Rive", 3),
                new Skill("Jest", 3),
                new Skill("Git", 2),
                new Skill("WebStorm", 4),
            ],
            [
            ],
            [
                "https://firebasestorage.googleapis.com/v0/b/portfolio-frederik.appspot.com/o/images%2Fllx2-min.png?alt=media&token=dcb527d1-2281-49d4-9564-134e8de4a669",
            ],
        ),
        new Project(
            "StarFeed",
            "Business Project",
            "An app, that aggregates reviews from different sources and lets the user see them through the app.",
            [
                new Skill("Flutter", 4),
                new Skill("Dart", 4),
                new Skill("Firebase", 4),
                new Skill("Google Admob", 3),
                new Skill("Trello", 2),
                new Skill("Git", 2),
                new Skill("Android Studio", 4),
            ],
            [],
            [
                "https://firebasestorage.googleapis.com/v0/b/portfolio-frederik.appspot.com/o/images%2Fstarfeed.png?alt=media&token=8788fb6b-ad46-494e-b474-cdb9bb34ead8",
            ],
        ),
        new Project(
            "Lumo",
            "Business Project",
            "I started on an app for a startup with two other people, where I would be in charge of the app. It is a Sports App, where people and organisations can manage their sports activities and other people can participate. I chose to leave this project due to the immense time it would take to make all the pages by myself as well as losing faith in the project.",
            [
                new Skill("Flutter", 4),
                new Skill("Dart", 4),
                new Skill("Firebase", 4),
                new Skill("Google Admob", 3),
                new Skill("Trello", 2),
                new Skill("Git", 2),
                new Skill("Android Studio", 4),
            ],
            [],
            [
                "https://firebasestorage.googleapis.com/v0/b/portfolio-frederik.appspot.com/o/images%2Flu1-min.png?alt=media&token=85fe332a-abdc-45af-91f5-cad2ad2d9a2d",
            ],
        ),
    ];
</script>

<section id="projects">
    <div id='container'>
        <div id='container-text'>
            <h1>Mobile apps</h1>
            <div style="height: 12px"/>
            <p>Here you can see most of the app projects, that I've done, and the tools and technologies, that I used for them. </p>
        </div>
        <div id="carousel">
            {#each projects as project}
                <ProjectDisplay {project} />
            {/each}
        </div>
    </div>
</section>


<style>
    #container {
        padding-left: 32px;
        padding-right: 0px;
        width: 100vw - 32px;
        height: calc(100vh - 80px);
        background-color: #fff;
        display: flex;
        justify-content: start;
        align-items: center;
        border-bottom: 5px solid rgba(0, 0, 0, 0.9);
    }

    #container-text {
        width: 30%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    #carousel {
        width: 70%;
        display: flex;
        flex-direction: row;
        overflow-x: auto; 
        white-space: nowrap;
        -ms-overflow-style: none;
        scrollbar-width: none;
    }

    h1 {
        font-size: 48px;
        color: rgba(0, 0, 0, 0.9);
        margin-top: 24px;
        margin-bottom: 0px;
    }

    p {
        color: rgba(0, 0, 0, 0.6);
        width: 70%;
        text-align: center;
        line-height: 1.3em;
    }

    @media (max-width: 952px) {
        #container {
            display: block;
            flex-direction: column;
            margin: 0px;
            padding: 0%;
            width: 100vw;
            height: auto;
        }
        #container-text {
            width: 100vw;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-bottom: 24px;
            margin-top: 48px;
        }
        #carousel {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            overflow-x: auto; 
            white-space: nowrap;
            -ms-overflow-style: none;
            scrollbar-width: none;
            margin-bottom: 48px;
        }
    }

</style>